import { useStyles } from "./IssueDescriptionExpandedCell.styles";
import { IIssueDescriptionExpandedCell } from "./IssueDescriptionExpandedCellInterfaces";

const IssueDescriptionExpandedCell = ({ issue }: IIssueDescriptionExpandedCell) => {
    const classes = useStyles();
    return (
        <div className={classes.descriptionWrapper}>
            <span>{issue.description}</span>
        </div>
    );
};

export default IssueDescriptionExpandedCell;
